import "./Hero01.css";

function Hero01() {
  return (
    <div className="Hero01 section" id="Hero01">
      <div className="Hero01-box">
        <div className="Hero01-text">
          <h1>
            Managing Tyre Waste
            <span> the Right Way.</span>
          </h1>

          <p>
            We provide fully compliant, efficient and advanced end-of-life tyre
            (ELT) collection and recycling services for businesses across the
            United Kingdom.
          </p>

          <div className="buttons">
            <a href="#Cta01" className="btn-3">
              GET IN TOUCH NOW
            </a>
            {/* <a href="/" className="btn-2">
              OR CALL US
            </a> */}
          </div>
        </div>

        <div className="Hero01-stats">
          <div className="Hero01-stats-slider">
            <div>
              <h3>
                500<span>+</span>
              </h3>
              <p className="small-font">TONS OF RESPONSIBLY MANAGED WASTE</p>
            </div>

            <div>
              <h3>
                200<span>+</span>
              </h3>
              <p className="small-font">TONS OF CO2 EMISSIONS SAVED</p>
            </div>

            <div>
              <h3>
                30<span>+</span>
              </h3>
              <p className="small-font">SURROUNDING COUNTIES COVERED</p>
            </div>

            <div>
              <h3>
                100<span>+</span>
              </h3>
              <p className="small-font">LOCAL BUSINESSES ALREADY SERVED</p>
            </div>

            <div>
              <h3>
                4.9/5<span>*</span>
              </h3>
              <p className="small-font">AVERAGE CUSTOMER RATING ONLINE</p>
            </div>
          </div>
          <div className="Hero01-stats-slider">
            <div>
              <h3>
                500<span>+</span>
              </h3>
              <p className="small-font">TONS OF RESPONSIBLY MANAGED WASTE</p>
            </div>

            <div>
              <h3>
                200<span>+</span>
              </h3>
              <p className="small-font">TONS OF CO2 EMISSIONS SAVED</p>
            </div>

            <div>
              <h3>
                30<span>+</span>
              </h3>
              <p className="small-font">SURROUNDING COUNTIES COVERED</p>
            </div>

            <div>
              <h3>
                100<span>+</span>
              </h3>
              <p className="small-font">LOCAL BUSINESSES ALREADY SERVED</p>
            </div>

            <div>
              <h3>
                4.9/5<span>*</span>
              </h3>
              <p className="small-font">AVERAGE CUSTOMER RATING ONLINE</p>
            </div>
          </div>
          <div className="Hero01-stats-slider">
            <div>
              <h3>
                500<span>+</span>
              </h3>
              <p className="small-font">TONS OF RESPONSIBLY MANAGED WASTE</p>
            </div>

            <div>
              <h3>
                200<span>+</span>
              </h3>
              <p className="small-font">TONS OF CO2 EMISSIONS SAVED</p>
            </div>

            <div>
              <h3>
                30<span>+</span>
              </h3>
              <p className="small-font">SURROUNDING COUNTIES COVERED</p>
            </div>

            <div>
              <h3>
                100<span>+</span>
              </h3>
              <p className="small-font">LOCAL BUSINESSES ALREADY SERVED</p>
            </div>

            <div>
              <h3>
                4.9/5<span>*</span>
              </h3>
              <p className="small-font">AVERAGE CUSTOMER RATING ONLINE</p>
            </div>
          </div>
          <div className="Hero01-stats-slider">
            <div>
              <h3>
                500<span>+</span>
              </h3>
              <p className="small-font">TONS OF RESPONSIBLY MANAGED WASTE</p>
            </div>

            <div>
              <h3>
                200<span>+</span>
              </h3>
              <p className="small-font">TONS OF CO2 EMISSIONS SAVED</p>
            </div>

            <div>
              <h3>
                30<span>+</span>
              </h3>
              <p className="small-font">SURROUNDING COUNTIES COVERED</p>
            </div>

            <div>
              <h3>
                100<span>+</span>
              </h3>
              <p className="small-font">LOCAL BUSINESSES ALREADY SERVED</p>
            </div>

            <div>
              <h3>
                4.9/5<span>*</span>
              </h3>
              <p className="small-font">AVERAGE CUSTOMER RATING ONLINE</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Hero01;
